import { Service, ServiceLimitType } from '@/models/service'

export const getServiceSingleLimit = ({
  service,
  dayDifference,
  seatsAmount = 0,
  serviceInCartQuantity,
  spotsAmount,
}: {
  service: Service
  dayDifference: number
  seatsAmount?: number
  serviceInCartQuantity?: number
  spotsAmount?: number
}) => {
  if (service.hasLimit && service.availableQuantity === 0) {
    return 0
  }

  const quantityInCart = serviceInCartQuantity ?? 0
  if (service.maximumLimitType === ServiceLimitType.NUMBER_OF_PIECES) {
    return Math.min(service.availableQuantity - quantityInCart, seatsAmount)
  }

  if (service.maximumLimitType === ServiceLimitType.NUMBER_OF_DAYS) {
    return Math.min(service.availableQuantity - quantityInCart, dayDifference)
  }

  if (service.maximumLimitType === ServiceLimitType.FLAT && service.hasLimit) {
    return (service.availableQuantity - quantityInCart) * (spotsAmount ?? 1)
  }

  return Infinity
}
